t = require('views/internal/teacup-with-helpers')('header_info_help_menu')
tip = require 'views/templates/tip_help'
header_info_link = require 'views/templates/header_info_link'
socialUrls = require('locale').social

module.exports = t.renderable ({ tips }) ->

  for tipData in tips
    tip(tipData)

  t.hr()

  t.ul '.meta-link-list', ->
    header_info_link 'help', 'http://help.trello.com', 'Help'
    header_info_link 'privacy', '/privacy', 'Privacy'

    t.span '.js-more-menu-button', ->
      header_info_link 'more'

    t.span '.js-more-menu.hide', ->
      header_info_link 'tour', '/tour', 'Tour'
      header_info_link 'pricing', '/pricing', 'Pricing'
      header_info_link 'apps', '/platforms', 'Apps'
      header_info_link 'blog', socialUrls.blog, 'Blog'
      header_info_link 'jobs', '/jobs', 'Jobs'
      header_info_link 'developers', 'https://developers.trello.com', 'Developers'
      header_info_link 'about', '/about', 'About'
      header_info_link 'legal', '/legal', 'Legal'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_info_help_menu.coffee